import { ONE_YEAR_IN_MILLISECONDS } from '../constants'

export function getCookie (cookieName) {
  const nameEQ = cookieName + '='
  const cookiesArray = document.cookie.split(';')

  for (let i = 0; i < cookiesArray.length; i++) {
    let cookie = cookiesArray[i]

    while (cookie.charAt(0) === ' ') cookie = cookie.substring(1, cookie.length)
    if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length, cookie.length)
  }

  return null
}

export function setCookie ({ cookieName = null, value = null, expiresIn = ONE_YEAR_IN_MILLISECONDS }) {
  const date = new Date()
  date.setTime(date.getTime() + expiresIn)
  const expires = `; expires=${date.toUTCString()}`

  if (
    cookieName &&
    value
  ) {
    document.cookie = `${cookieName}=${value}${expires}; path=/`
  }
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js